const state = {
  // 系统样式
  systemStyle: {
    // 主题风格
    theme: 'light'
  }
}
const mutations = {
}
const actions = {
  adjustElementSize() {
    const appElement = document.getElementById("app");
    if (!appElement) return;
    const windowWidth = window.innerWidth;

    const baseWidth = 1980;

    const widthRatio = windowWidth / baseWidth;

    if (widthRatio > 1) {
      appElement.style.zoom = widthRatio * 0.96;
    } else {
      appElement.style.zoom = widthRatio * 1.05;
    }
  },
  addEventListener() {
    window.addEventListener("resize", this.adjustElementSize);
  },
  removeEventListener() {
    window.removeEventListener("resize", this.adjustElementSize);
  },
}
const getters = {

}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
